<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1"
    variant="outlined"
    @click="isActive = true"
  ></v-btn>
  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="300">
        <v-form @submit.prevent enctype="multipart/form-data" ref="form">
          <!-- {{ parents }} -->
          <!-- {{ formData }} -->
          <v-select
            v-model="formData.parent.id"
            :items="parents"
            label="العداد الأب"
            item-title="name"
            item-text="code"
            item-value="id"
          >
          </v-select>
          <v-select
            v-model="formData.status"
            label="الحالة"
            :items="statuses"
            item-title="name"
          >
          </v-select>
          <v-text-field
            v-model="formData.code"
            :rules="codeRules"
            label="الرقم"
          ></v-text-field>
          <v-text-field
            v-model="formData.name"
            :rules="nameRules"
            label="الاسم"
          ></v-text-field>

          <v-checkbox v-model="formData.isFinal" label="عداد زبون"></v-checkbox>
        </v-form>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="حفظ" @click="save"></v-btn>

        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["saveFunction", "item", "mode", "iconName", "parents"],
  data() {
    return {
      isActive: false,
      statuses: ["working", "free", "deleted", "bad", "fixing"],
      formData: {
        code: "",
        name: "",
        status: "",
        parent_id: "",
        isFinal: false,
        parent: {
          id: "",
          name: "",
          code: "",
        },
      },
      fullnameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      emailRules: [(v) => !!v || "Email is required"],
      phoneRules: [(v) => !!v || "Phone is required"],
      passwordRules: {
        required: (v) => !!v || "Password is required",
        optional: () => true, // Always returns true, making the field optional
      },
    };
  },
  methods: {
    async validate() {
      const { valid } = await this.$refs.form.validate();

      if (valid) alert("Form is valid");
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        this.formData.parent_id = this.formData.parent.id;
        console.log("form data", this.formData);
        this.saveFunction(this.formData, this.mode);

        this.isActive = false;
      }
    },
    close() {
      this.isActive = false;
    },
    checkChanged() {
      console.log("ccc", "check changed");
    },
  },
  watch: {
    isActive(value) {
      if (value) {
        if (this.mode == "edit") {
          this.formData = { ...this.item };
          if (this.formData.parent == null) {
            this.formData.parent = {};
          }
          this.formData.isFinal = this.formData.isFinal == 1 ? true : false;
        }
      }
    },
  },
  computed: {
    title() {
      if (this.mode == "add") return "إضافة عداد";
      return "تعديل عداد";
    },
  },
};
</script>
